// extracted by mini-css-extract-plugin
export default {"pedido":"Pedido_pedido__mXh+6"};